import React from 'react';
import { map } from 'lodash';
import { observer } from 'mobx-react';
import useStyles from './TextAssetsTab.styles';
import { List, ListItem, TextField } from '@material-ui/core';
import { useTextAssetsTab } from './hooks/useTextAssetsTab';

export const TextAssetsTab: React.FC = observer(() => {
  const classes = useStyles();
  const { placeholder, maxLength, textAssets, handleChange } = useTextAssetsTab();
  return (
    <List className={classes.list}>
      {map(textAssets, (asset, index) => (
        <ListItem key={index} className={classes.item}>
          <TextField
            fullWidth
            multiline
            size="small"
            value={asset.text}
            variant="outlined"
            placeholder={placeholder}
            inputProps={{ maxLength }}
            className={classes.textField}
            helperText={`${asset.text.length}/${maxLength}`}
            onChange={(e) => handleChange(e.target.value, asset.id)}
          />
        </ListItem>
      ))}
    </List>
  );
});
